import { z } from 'zod';

export const kpiSchema = z.object({
  metric_name: z.string()
    .min(1, 'Debe seleccionar una métrica'),
  threshold_value: z.number()
    .int('El valor umbral debe ser un número entero')
    .min(0, 'El valor umbral debe ser al menos 0')
    .max(1000000, 'El valor umbral no puede exceder 1,000,000'),
  condition: z.enum(['greater_than', 'less_than', 'equal_to'], {
    required_error: 'Debe seleccionar una condición',
  }),
  notification_enabled: z.boolean(),
});

export type KPIInput = z.infer<typeof kpiSchema>;
